// import { ADD_MEDICINE, FETCH_MEDICINES, EDIT_MEDICINES, DELETE_MEDICINE } from '../constants/actionTypes.js';
// import * as api from '../api/index.js';

// export const addMedicine = (details) => async (dispatch) => {
//     console.log(details);
//     console.log('yo yo');
    
//     try {

//         const {data} = await api.addMedicine(details)
//         console.log(data);
        
//         dispatch({ type: ADD_MEDICINE, payload: data.inventory });

//     } catch (error) {
//         console.error(error.response?.data);    // ← log the server’s JSON
//         console.error(error.response?.status);
//         // console.log(error);
        
//     }
// }



// // params is an object like { expiryLteDays: 7 } or { expired: true } or {}
// // export const fetchMedicines = (params = {}) => async (dispatch) => {
// //   try {
// //     const { data } = await api.fetchMedicines(params);
// //     dispatch({ type: FETCH_MEDICINES, payload: data });
// //   } catch (err) {
// //     console.error('fetchMedicines failed:', err);
// //   }
// // };

// export const fetchMedicines = (params = {}) => async (dispatch) => {
//   try {
//     const query =
//       typeof params === 'string' ? { filter: params } :
//       (params && typeof params === 'object' ? params : {});

//     const { data } = await api.fetchMedicines(query); // axios get('/products', { params: query })
//     dispatch({ type: FETCH_MEDICINES, payload: data });
//   } catch (err) {
//     console.error('fetchMedicines failed:', err);
//   }
// };

// export const editMedicine = (id, updates) => async (dispatch) => {
//   try {
//     const { data } = await api.updateMedicine(id, updates);
//     dispatch({ type: EDIT_MEDICINES, payload: data.inventory });
//     console.log(id, updates);
    
//   } catch (err) {
//     console.error('editMedicine failed:', err.response?.data || err);
//   }
// };

// export const deleteMedicine = (id) => async (dispatch) => {
//   try {
//     const { data } = await api.deleteMedicine(id);
//     dispatch({ type: DELETE_MEDICINE, payload: id });
//     console.log("Deleted:", id, data);
//   } catch (err) {
//     console.error('deleteMedicine failed:', err.response?.data || err);
//   }
// };


// export const restockMedicine = ({ existingId, units }) => async (dispatch) => {
//   try {
//     const { data } = await api.restockMedicine(existingId, { units });
//     dispatch({ type: EDIT_MEDICINES, payload: data.inventory });
//   } catch (err) {
//     console.error('restockMedicine failed:', err.response?.data || err);
//   }
// };



// export const adjustStock = ({ inventoryId, mode, newQty, delta, reason, note }) => async (dispatch) => {
//   console.log('hehe');

//   try {
//     const payload = { mode, reason, note };

//     if (mode === 'SET') payload.newQty = newQty;
//     if (mode === 'DELTA') payload.delta = delta;

//     const res = await api.adjustStock(inventoryId, payload); // <- don't destructure yet
//     const data = res.data;

//     dispatch({ type: EDIT_MEDICINES, payload: data.inventory });
//     return data;
//   } catch (err) {
//     console.error('adjustStock failed:', err.response?.data || err);
//     throw err;
//   }
// };

import {
  ADD_INVENTORY,
  FETCH_INVENTORY,
  UPDATE_INVENTORY,
  DELETE_INVENTORY,
} from "../constants/actionTypes.js";
import { SHOW_SNACKBAR } from "../constants/actionTypes.js";

import * as api from "../api/index.js";

const getStockSeverityAndMessage = (inv) => {
  if (!inv) return null;

  const qty   = typeof inv.quantity === "number" ? inv.quantity : null;
  const lowT  =
    typeof inv.lowStockThreshold === "number" && Number.isFinite(inv.lowStockThreshold)
      ? inv.lowStockThreshold
      : null;
  const critT =
    typeof inv.criticalThreshold === "number" && Number.isFinite(inv.criticalThreshold)
      ? inv.criticalThreshold
      : null;

  if (qty == null) return null; // no alerts for this batch

  // Try to build a readable name
  const item   = inv.itemId || {};
  const med    = item.medicineId || {};
  const name =
    inv.displayName ||
    inv.medicineName ||
    inv.itemName ||
    item.name ||
    med.brandName ||
    med.genericName ||
    "Item";

  // Out of stock
  if (qty <= 0) {
    return {
      severity: "error",
      message: `Out of Stock - ${name} is out of stock.`,
    };
  }

  // Critically low (if critT present, otherwise derived in backend but we keep this simple)
  if (critT != null && qty <= critT) {
    return {
      severity: "warning",
      message: `Critically Low - ${name} has ${qty} units remaining.`,
    };
  }

  // Low stock
  if (qty <= lowT) {
    return {
      severity: "info",
      message: `Low Stock Alert - ${name} has ${qty} units remaining.`,
    };
  }

  // Stock is “healthy” → no snackbar
  return null;
};

const maybeShowStockSnackbar = (dispatch, inventory) => {
  const payload = getStockSeverityAndMessage(inventory);
  if (!payload) return;

  dispatch({
    type: SHOW_SNACKBAR,
    payload,
  });
};


// POST /products  (backend returns { inventory: populatedDoc })
export const addInventory = (details) => async (dispatch) => {
  try {
    const { data } = await api.addInventory(details);
    dispatch({ type: ADD_INVENTORY, payload: data.inventory });
    maybeShowStockSnackbar(dispatch, data.inventory);
    
    return data.inventory;
  } catch (error) {
    console.error(error.response?.data);
    console.error(error.response?.status);

    dispatch({
      type: SHOW_SNACKBAR,
      payload: {
        severity: "error",
        message: "Error - Failed to add stock.",
      },
    });
    throw error;
  }
};

// GET /products?...
export const fetchInventory = (params = {}) => async (dispatch) => {
  try {
    const query =
      typeof params === "string"
        ? { filter: params }
        : params && typeof params === "object"
          ? params
          : {};

    const { data } = await api.fetchInventory(query);
    dispatch({ type: FETCH_INVENTORY, payload: data });
    return data;
  } catch (err) {
    console.error("fetchInventory failed:", err.response?.data || err);
    throw err;
  }
};

// PATCH /products/:id  (backend returns { inventory: populatedDoc })
export const updateInventory = (id, updates) => async (dispatch) => {
  try {
    const { data } = await api.updateInventory(id, updates);
    dispatch({ type: UPDATE_INVENTORY, payload: data.inventory });

    maybeShowStockSnackbar(dispatch, data.inventory);

    return data.inventory;
  } catch (err) {
    console.error("updateInventory failed:", err.response?.data || err);

    dispatch({
      type: SHOW_SNACKBAR,
      payload: {
        severity: "error",
        message: "Error - Failed to update inventory item.",
      },
    });
    throw err;
  }
};

// DELETE /products/:id  (backend returns { message, id })
export const deleteInventory = (id) => async (dispatch) => {
  try {
    await api.deleteInventory(id);
    dispatch({ type: DELETE_INVENTORY, payload: id });
    return id;
  } catch (err) {
    console.error("deleteInventory failed:", err.response?.data || err);
    throw err;
  }
};

// POST /products/:id/restock  (backend returns { inventory: populatedDoc })
export const restockInventory = ({ inventoryId, units }) => async (dispatch) => {
  try {
    const { data } = await api.restockInventory(inventoryId, { units });
    dispatch({ type: UPDATE_INVENTORY, payload: data.inventory });

    maybeShowStockSnackbar(dispatch, data.inventory)
    return data.inventory;
  } catch (err) {
    console.error("restockInventory failed:", err.response?.data || err);

    dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          severity: "error",
          message: "Error - Failed to restock.",
        },
      });
    throw err;
  }
};

// POST /products/:id/adjust  (backend returns { inventory: populatedDoc })
export const adjustStock = ({ inventoryId, mode, newQty, delta, reason, note }) => async (dispatch) => {
  try {
    const payload = { mode, reason, note };
    if (mode === "SET") payload.newQty = newQty;
    if (mode === "DELTA") payload.delta = delta;

    const { data } = await api.adjustStock(inventoryId, payload);

    dispatch({ type: UPDATE_INVENTORY, payload: data.inventory });

    maybeShowStockSnackbar(dispatch, data.inventory);
    return data.inventory;
  } catch (err) {
    console.error("adjustStock failed:", err.response?.data || err);
    dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          severity: "error",
          message: "Error - Failed to adjust stock.",
        },
      });
    throw err;
  }
};
